import type { IGymAddress } from '@rogue/universal'

export function formatGymAddress(address: IGymAddress | undefined | null, hideStreet = false): string {
  if (!address) {
    return ''
  }

  let prettyAddress = hideStreet ? '' : (address.street || []).join(' ').trim()

  if (address.city) {
    if (prettyAddress.trim()) {
      prettyAddress += `, ${address.city}`
    } else {
      prettyAddress = address.city
    }
  }

  if (address.region) {
    if (prettyAddress.trim()) {
      prettyAddress += `, ${address.region}`
    } else {
      prettyAddress = address.region
    }
  }

  if (address.postcode) {
    prettyAddress += ` ${address.postcode}`
  }

  if (address.countryId) {
    prettyAddress += `, ${address.countryId}`
  }

  return prettyAddress
}

// Convert degrees to radians
function toRadians(degrees: number) {
  return degrees * (Math.PI / 180)
}

function toDegrees(radians: number) {
  return (radians * 180) / Math.PI
}

// Calculate distance between two points using the Haversine formula
export function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number, useMiles: boolean) {
  const R = useMiles ? 3963 : 6371 // Earth's radius in kilometers or miles

  const dLat = toRadians(lat2 - lat1)
  const dLon = toRadians(lon2 - lon1)

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2))
            * Math.sin(dLon / 2) * Math.sin(dLon / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c // Distance in kilometers
}
